(function () {
  'use strict';

  var SELECTOR = '[data-norbites-cart-upsell]';
  var MOBILE_QUERY = '(max-width: 767px)';
  var priceRefreshTimer;
  var priceRefreshInFlight = false;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function routeRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function updateArrow(track, button) {
    if (!track || !button) return;
    var remaining = track.scrollWidth - track.clientWidth - track.scrollLeft;
    button.hidden = remaining <= 8;
  }

  function decodePriceText(text) {
    var value = String(text || '').trim();
    if (!value) return '';
    if (value.indexOf('<') === -1) return value;

    var decoder = document.createElement('div');
    decoder.innerHTML = value;
    return (decoder.textContent || decoder.innerText || '').trim();
  }

  function parseDisplayedMoney(text) {
    var value = decodePriceText(text);
    var match = value.match(/-?\d[\d\s.,]*/);
    if (!match) return null;

    var raw = match[0].trim();
    var compact = raw.replace(/\s/g, '');
    var comma = compact.lastIndexOf(',');
    var dot = compact.lastIndexOf('.');
    var decimalIndex = Math.max(comma, dot);
    var decimalSeparator = decimalIndex >= 0 ? compact.charAt(decimalIndex) : '.';

    if (decimalIndex >= 0 && compact.length - decimalIndex - 1 === 2) {
      compact = compact.slice(0, decimalIndex).replace(/[.,]/g, '') + '.' + compact.slice(decimalIndex + 1);
    } else {
      compact = compact.replace(/[.,]/g, '');
    }

    var amount = Number(compact);
    if (!Number.isFinite(amount)) return null;

    return {
      amount: amount,
      prefix: value.slice(0, match.index),
      suffix: value.slice(match.index + match[0].length),
      decimalSeparator: decimalSeparator
    };
  }

  function deriveCartMoneyContext(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;

    for (var i = 0; i < cart.items.length; i += 1) {
      var line = document.querySelector('#mini__cart .media-link[data-line="' + (i + 1) + '"]');
      if (!line) continue;

      var priceNode = line.querySelector('.yv-product-price');
      if (!priceNode) continue;

      var displayed = parseDisplayedMoney(priceNode.textContent || '');
      var rawCents = Number(cart.items[i].final_line_price);
      if (!displayed || !Number.isFinite(rawCents) || rawCents <= 0) continue;

      var rawAmount = rawCents / 100;
      var rate = displayed.amount / rawAmount;
      if (!Number.isFinite(rate) || rate <= 0) continue;

      return {
        rate: rate,
        prefix: displayed.prefix,
        suffix: displayed.suffix,
        decimalSeparator: displayed.decimalSeparator
      };
    }

    return null;
  }

  function formatLikeCart(baseAmount, context) {
    if (!Number.isFinite(baseAmount) || !context) return '';

    var converted = baseAmount * context.rate;
    var locale = context.decimalSeparator === ',' ? 'nb-NO' : 'en-US';
    var number;

    try {
      number = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(converted);
    } catch (error) {
      number = converted.toFixed(2);
      if (context.decimalSeparator === ',') number = number.replace('.', ',');
    }

    return context.prefix + number + context.suffix;
  }

  function rememberBasePrices(section) {
    section.querySelectorAll('.norbites-cart-upsell__price').forEach(function (price) {
      if (price.dataset.norbitesBasePrice) return;

      var parsed = parseDisplayedMoney(price.textContent || '');
      if (parsed) price.dataset.norbitesBasePrice = String(parsed.amount);
      price.textContent = decodePriceText(price.textContent || '');
    });
  }

  function refreshAllPrices() {
    if (priceRefreshInFlight) return;

    var sections = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!sections.length) return;

    sections.forEach(rememberBasePrices);
    priceRefreshInFlight = true;

    fetch(routeRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        var context = deriveCartMoneyContext(cart);
        if (!context) return;

        sections.forEach(function (section) {
          section.querySelectorAll('.norbites-cart-upsell__price').forEach(function (price) {
            var baseAmount = Number(price.dataset.norbitesBasePrice);
            if (!Number.isFinite(baseAmount)) return;

            var formatted = formatLikeCart(baseAmount, context);
            if (formatted && price.textContent !== formatted) price.textContent = formatted;
          });
        });
      })
      .catch(function () {
        // Price conversion is presentational only; leave the recommendation usable.
      })
      .finally(function () {
        priceRefreshInFlight = false;
      });
  }

  function schedulePriceRefresh(delay) {
    window.clearTimeout(priceRefreshTimer);
    priceRefreshTimer = window.setTimeout(refreshAllPrices, typeof delay === 'number' ? delay : 120);
  }

  function integrateCartLayout() {
    var drawerBody = document.querySelector('#mini__cart [data-drawer-body]');
    if (!drawerBody) return;

    var itemsWrapper = drawerBody.querySelector('.cart-items-wrapper');
    var footer = drawerBody.querySelector('.bottom-cart-box');
    var note = drawerBody.querySelector('.leave-order-note');

    if (isMobile()) {
      if (itemsWrapper && note && !itemsWrapper.contains(note)) {
        note.classList.add('norbites-cart-note-inline');
        itemsWrapper.appendChild(note);
      }
    } else if (footer && note && note.classList.contains('norbites-cart-note-inline')) {
      note.classList.remove('norbites-cart-note-inline');
      footer.insertBefore(note, footer.firstChild);
    }
  }

  function polish(section) {
    if (!section) return;

    var heading = section.querySelector('.norbites-cart-upsell__heading');
    var track = section.querySelector('.norbites-cart-upsell__track');
    var hint = section.querySelector('.norbites-cart-upsell__hint');
    if (!track) return;

    if (heading) heading.textContent = 'You might also like';
    if (hint) hint.remove();
    rememberBasePrices(section);
    integrateCartLayout();

    var cartItems = section.closest('.cart-item-container');
    var itemsWrapper = cartItems ? cartItems.querySelector('.cart-items-wrapper') : null;
    if (isMobile() && itemsWrapper && section.parentElement !== itemsWrapper) {
      var inlineNote = itemsWrapper.querySelector('.norbites-cart-note-inline');
      if (inlineNote) {
        itemsWrapper.insertBefore(section, inlineNote);
      } else {
        itemsWrapper.appendChild(section);
      }
    }

    schedulePriceRefresh(40);
    window.setTimeout(refreshAllPrices, 350);
    window.setTimeout(refreshAllPrices, 900);

    if (section.dataset.norbitesPolished === 'true') return;

    var trackWrap = document.createElement('div');
    trackWrap.className = 'norbites-cart-upsell__track-wrap';
    track.parentNode.insertBefore(trackWrap, track);
    trackWrap.appendChild(track);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'norbites-cart-upsell__next';
    button.setAttribute('aria-label', 'Show more recommendations');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    trackWrap.appendChild(button);

    button.addEventListener('click', function () {
      var firstCard = track.querySelector('.norbites-cart-upsell__card');
      var distance = firstCard ? firstCard.getBoundingClientRect().width + 10 : Math.max(240, track.clientWidth * 0.85);
      track.scrollBy({ left: distance, behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      updateArrow(track, button);
    }, { passive: true });

    window.addEventListener('resize', function () {
      integrateCartLayout();
      schedulePriceRefresh();
      updateArrow(track, button);
    }, { passive: true });

    section.dataset.norbitesPolished = 'true';
    window.requestAnimationFrame(function () {
      updateArrow(track, button);
    });
  }

  function scan(root) {
    integrateCartLayout();
    if (!root) return;
    if (root.matches && root.matches(SELECTOR)) polish(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(polish);
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      var externalPriceChange = false;
      integrateCartLayout();

      mutations.forEach(function (mutation) {
        var targetElement = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;

        if (targetElement && !targetElement.closest(SELECTOR)) externalPriceChange = true;

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });

      if (externalPriceChange) schedulePriceRefresh(180);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    var mediaQuery = window.matchMedia(MOBILE_QUERY);
    var onViewportChange = function () {
      integrateCartLayout();
      document.querySelectorAll(SELECTOR).forEach(polish);
      schedulePriceRefresh();
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', onViewportChange);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(onViewportChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
